import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import type { DropdownOption } from 'ui-components/components/dropdown/dropdown-types';

import { useSortedTranslatedCountries } from '../../../../../hooks/use-sorted-translated-countries';
import { useProductDetailsContext } from '../../../use-product-details-context';
import { messages } from '../../../messages';

const getOptionValue = (option: DropdownOption) => option.code as string;
const getOptionLabel = (option: DropdownOption) => option.label ?? '';

export const OriginCountryDropdown = () => {
  const { customsOriginCountry, setCustomsOriginCountry, userHasPermission } = useProductDetailsContext();
  const countries = useSortedTranslatedCountries();
  const intl = useIntl();

  const onItemSelected = useCallback(
    (value: string | undefined) => {
      setCustomsOriginCountry(value ?? undefined);
    },
    [setCustomsOriginCountry],
  );

  return (
    <SearchableDropdownField
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      id='origin-country-dropdown'
      isClearable
      isDisabled={!userHasPermission}
      onItemSelected={onItemSelected}
      options={countries as DropdownOption[]}
      placeholder={intl.formatMessage(messages.customsOriginCountry)}
      selectedItemValue={customsOriginCountry}
    />
  );
};
